import { AlertCircle, LogOut } from "lucide-react";

import { useAuth } from "../../context/AuthContext";
import { useEmailVerificationReminder } from "../../features/auth/useEmailVerificationReminder";

export const EmailVerificationGate = () => {
  const { logout } = useAuth();
  const { cooldown, resending, resendVerification } = useEmailVerificationReminder();

  const handleResend = () => {
    if (cooldown > 0 || resending) return;
    resendVerification();
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 bg-white p-10 rounded-xl shadow-lg text-center">
        <AlertCircle className="text-yellow-500 mx-auto" size={48} />
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
          Email verification required
        </h2>
        <p className="mt-2 text-sm text-gray-600">
          Your account was created, but you need to verify your email address to gain full access.
          Check your inbox for the verification link.
        </p>
        <div className="mt-6">
          <button
            onClick={handleResend}
            disabled={cooldown > 0 || resending}
            className={`${
              cooldown > 0 || resending
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-blue-600 hover:bg-blue-700"
            } text-white font-bold py-2 px-4 rounded-md transition`}
          >
            {cooldown > 0 ? `Resend in ${cooldown}s` : "Resend verification email"}
          </button>
        </div>
        <p className="mt-4">
          <button
            onClick={logout}
            className="text-blue-600 hover:text-blue-800 font-medium mt-2 flex items-center justify-center mx-auto"
          >
            <LogOut className="mr-2" size={18} /> Log out and try again
          </button>
        </p>
      </div>
    </div>
  );
};
